/**
 * **أيُّ بندٍ في القائمة هو النشط؟ — الأخصُّ يفوز.**
 *
 * عطبٌ أدخلتُه في N-370: `TanStack Router` يطابق البادئة افتراضًا، فـ`/personal`
 * يبقى نشطًا على `/personal/notebook` — فيُضاء **بندان معًا**، والمالك يضغط
 * «المفكرة» فتتحدّد «شخصي» كذلك (بلاغه 2026-10-14).
 *
 * و`exact` وحدها ليست العلاج: لو فُرضت على «شخصي» لفقد إضاءته على `/personal/ideas`
 * و`/personal/archive` وبقيّة وجهاته — فيُصلَح عطبٌ بإدخال آخر.
 *
 * فالقاعدة: يُطابق البند بادئةً، **ثم يخسر إن طابق بندٌ أطول منه**. فعلى
 * `/personal/notebook` يفوز «المفكرة» (أطول)، وعلى `/personal/ideas` يبقى
 * «شخصي» وحده مطابقًا فيفوز.
 *
 * **و«اليوم» (`/`) لا يحتاج استثناءً** — وقد كتبتُ له واحدًا ثم أسقطته الطفرة:
 * حذفُه لم يُسقط حالة. والعلّة أن الشرط `${target}/` يصير للجذر `//` لا `/`،
 * فلا يطابق شيئًا، ويبقى `pathname === '/'` وحده. فالفرع كان ميّتًا وتعليقُه
 * يدّعي ضرورةً لا وجود لها.
 *
 * وحدُّ الفاصلة مقصود كذلك: `startsWith('/tasks/')` لا `startsWith('/tasks')` —
 * وإلّا أضاء «المهام» على `/tasks-archive` لو وُجد يومًا.
 */
export function isNavActive(
  pathname: string,
  to: string,
  targets: readonly string[],
): boolean {
  const hits = (target: string): boolean =>
    pathname === target || pathname.startsWith(`${target}/`);

  if (!hits(to)) return false;
  return !targets.some((other) => other !== to && other.length > to.length && hits(other));
}
